import $ from 'jquery';

Drupal.behaviors.beijertechgroupMainNavigation = {
  attach: function (context) {
    const $button   = $('.toggle-menu-button', context);
    const $menuItem = $('nav .menu-item--has-children > a', context);

    $menuItem.unbind().on('beijertechgroupMainNavigation').on('click', function( e ) {
      e.preventDefault();
      e.stopPropagation();

      let $target = $(e.target).closest('li.menu-item--has-children');
      let isOpen = $target.hasClass('expanded');

      $('li.menu-item--has-children').removeClass('expanded');
      if (!isOpen) {
        $target.toggleClass('expanded');
      }
    });

    $button.unbind().on('beijertechgroupMainNavigation').on('click', function() {
      $('html').toggleClass('show-menu');
      $(this).toggleClass('icon--cross');
    });
  }
};
